// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-container[data-v-8259fc3c] {\n    position: relative;\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n}\n.w-responsive-iframe[data-v-8259fc3c] {\n    /* position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0; */\n    width: 100%;\n    height: 100%;\n}\n.w-iframe-waiting[data-v-8259fc3c] {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 4;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
